import { render, staticRenderFns } from "./AdminPromotionManage.vue?vue&type=template&id=116674ab&scoped=true"
import script from "./AdminPromotionManage.vue?vue&type=script&lang=js"
export * from "./AdminPromotionManage.vue?vue&type=script&lang=js"
import style0 from "./AdminPromotionManage.vue?vue&type=style&index=0&id=116674ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116674ab",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
